import * as React from "react";
import { useCallback, useContext, useMemo } from "react";
import { updateWidgetConfig } from "views/logic/slices/widgetActions";
import useViewsDispatch from "views/stores/useViewsDispatch";
import LogViewWidget from "logview/components/LogViewWidget";
import reexecuteSearchTypes from "views/components/widgets/reexecuteSearchTypes";
import useOnSearchExecution from "views/hooks/useOnSearchExecution";
import MessageDetailsContext from "logview/components/contexts/MessageDetailsContext";
import { fetchMessage } from "views/hooks/useMessage";
import Field from "views/components/Field";
import DecoratedValue from "views/components/messagelist/decoration/DecoratedValue";
import Value from "views/components/Value";
import useAutoRefresh from "views/hooks/useAutoRefresh";
import useFeature from "hooks/useFeature";
import BulkActions from "logview/ViewsLogViewWidget/BulkActions";
import LogViewWidgetConfig from "../logic/LogViewWidgetConfig";
const ResetListState = ({ resetListState }) => {
  const { setActiveMessageDetailsState } = useContext(MessageDetailsContext);
  useOnSearchExecution(() => {
    resetListState();
    setActiveMessageDetailsState(void 0);
  });
  return null;
};
const formatBackendMessages = (messages) => [...messages].reverse().map((message) => ({ ...message, frontendId: message.message._id, message: { ...message.message } }));
const ViewsLogViewWidget = ({
  config,
  data,
  queryId,
  id,
  setLoadingState,
  editing,
  fields
}) => {
  const isFavoriteMessageFieldsEnabled = useFeature("message_table_favorite_fields");
  const dispatch = useViewsDispatch();
  const { stopAutoRefresh } = useAutoRefresh();
  const onChangeConfig = useCallback(
    (newConfig) => dispatch(updateWidgetConfig(id, newConfig)),
    [dispatch, id]
  );
  const onLoadMessages = useCallback(
    async (after) => {
      const result = await dispatch(reexecuteSearchTypes({ [data.id]: { after } }, data.effectiveTimerange));
      const searchTypeResult = result.payload.result.results[queryId].searchTypes[data.id];
      return { messages: formatBackendMessages(searchTypeResult.messages), after: searchTypeResult.after };
    },
    [data.id, data.effectiveTimerange, dispatch, queryId]
  );
  const onLoadMessage = useCallback(
    (message) => fetchMessage(message.index, message.message._id),
    []
  );
  const sortedMessages = useMemo(() => formatBackendMessages(data.messages), [data.messages]);
  const renderFieldName = useCallback(
    (field, fieldType) => /* @__PURE__ */ React.createElement(Field, { name: field, type: fieldType }),
    []
  );
  const renderFieldValue = useCallback(
    (field, fieldType, value) => /* @__PURE__ */ React.createElement(Value, { field, value, type: fieldType, render: DecoratedValue }),
    []
  );
  const bulkSelection = {
    actions: /* @__PURE__ */ React.createElement(BulkActions, null)
  };
  return /* @__PURE__ */ React.createElement(
    LogViewWidget,
    {
      bulkSelection,
      config,
      defaultFields: LogViewWidgetConfig.defaultFields,
      onLoadMessage,
      effectiveTimerange: data.effectiveTimerange,
      messages: sortedMessages,
      initialAfter: data.after,
      loadedAllMessages: (loadedMessagesCount, after) => data.total !== void 0 && loadedMessagesCount === data.total || !after,
      renderFieldName,
      renderFieldValue,
      onLoadMessages,
      editing,
      setLoadingState,
      fields,
      onChangeConfig,
      onOpenMessageDetails: stopAutoRefresh,
      isFavoriteMessageFieldsEnabled
    },
    ({ resetListState }) => /* @__PURE__ */ React.createElement(ResetListState, { resetListState })
  );
};
export default ViewsLogViewWidget;
